export default __webpack_public_path__ + "static/contact-bg-bbc4440a19a940ac27d1a41f8b1ec591.png";